module.exports = __webpack_public_path__ + "img/9788959137169.778fd7f2.jpg";